import classNames from 'classnames';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import { useToggle } from 'usehooks-ts';

export function EligibilityInfo({ className }: { className?: string }) {
  const [opened, toggle] = useToggle(false);
  return (
    <>
      <button className={classNames('btn btn-flat-primary btn-sm btn-icon', className)} onClick={toggle}>
        <i className="icon icon-sm clickable">info_outline</i>
      </button>

      <Modal show={opened}>
        <Modal.Header closeButton onHide={toggle}>
          <Modal.Title>
            <FormattedMessage id="underlying.esgEligibility.modalTitle" />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="list-group flex-y gap-3">
            <div className="flex-x gap-2 align-items-start">
              <i className="icon text-success">check_circle</i>
              <div className="flex-y gap-1 mt-1">
                <span>
                  <FormattedMessage id="underlying.esgEligibility.eligible" />
                </span>
                <span className="text-secondary">
                  <FormattedMessage id="underlying.esgEligibility.eligible.description" />
                </span>
              </div>
            </div>

            <div className="flex-x gap-2 align-items-start">
              <i className="icon text-success">check_circle_outline</i>
              <div className="flex-y gap-1 mt-1">
                <span>
                  <FormattedMessage id="underlying.esgEligibility.eligibleWithCondition" />
                </span>
                <span className="text-secondary">
                  <FormattedMessage
                    id="underlying.esgEligibility.eligibleWithCondition.description"
                    values={{ paragraph: chunk => <p className="mt-3">{chunk}</p> }}
                  />
                </span>
              </div>
            </div>

            <div className="text-secondary" style={{ marginLeft: '32px' }}>
              <FormattedMessage
                id="underlying.esgEligibility.eligibleWithCondition.contact"
                values={{
                  link: chunk => (
                    <a className="text-link" href={`mailto:${chunk}`}>
                      {chunk}
                    </a>
                  ),
                }}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="btn btn-lg btn-default" onClick={toggle}>
            <FormattedMessage id="ok" />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
